import { requiredError, fieldLabels } from './errorMessage';

export function validateDCQ(data) {
  // Check specifically for whitespace-only values in new_value before trimming
  if (typeof data.new_value === 'string' && data.new_value.trim() === '' && data.new_value !== '') {
    // If it's all whitespace (but not empty), set a specific error
    const errors = { new_value: 'New Value cannot consist of only whitespace.' };
    return { trimmed: data, errors };
  }

  const trimmed = Object.fromEntries(
    Object.entries(data).map(([key, val]) => [key, typeof val === 'string' ? val.trim() : val])
  );

  const errors = {};
  const requiredFields = Object.keys(fieldLabels);

  for (const field of requiredFields) {
    if (!trimmed[field]) {
      errors[field] = requiredError(field);
    }
  }

  // Updated valid DCQ types to match the dropdown options
  const validDCQTypes = [
    'query',
    'deviation',
    'protocol violation',
    'data clarification',
    'missing data',
    'other',
    'correction',
    'clarification',
    'update'
  ];

  if (trimmed.type && !validDCQTypes.includes(trimmed.type.toLowerCase())) {
    errors.type = 'Invalid DCQ type.';
  }

  if (trimmed.new_value === trimmed.initial_value) {
    errors.new_value = 'New value must be different from initial value.';
  }

  if (trimmed.reason_for_change && trimmed.reason_for_change.length < 10) {
    errors.reason_for_change = 'Please provide more detail for the reason.';
  }

  return { trimmed, errors };
}